import BubbleService from "../BubbleService";

class OtpService extends BubbleService {
    constructor() {
        super();
    }

    sendOTP = async (email: string, type: string) => {
        await this.revokeOTP(email)
        const otp = this.generateOTP()
        const data = await this.postWf('create_otp', { email, otp, type })
        setTimeout(()=>{
            this.revokeOTP(email)
        },35000)
        return true
    }

    resendOTP = async (email: string, type: string) => {
        await this.revokeOTP(email)
        await this.sendOTP(email,type)
    }

    revokeOTP = async (email: string) => {
        const data = await this.postWf('revoke_otp',{email})
    }

    verifyOTP = async (email: string, type: string, otp: string,applicationId:string) => {
        const result:any = await this.postWf('verify_otp',{email,otp,type,applicationId})
        if(result.status == 'success'){
            await this.revokeOTP(email)
            return true
        }else{
            return false
        }
    }

    private generateOTP = () => {
        const otp = Math.floor(100000 + Math.random() * 900000)
        return otp.toString()
    }
}

export default OtpService;
